import { useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { AgreementsDashboardQueryKeys } from "modules/AgreementsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useAgreementsQuery = () => {
  const { selectedDealer } = useSelectedDealer();

  return useTypedQuery({
    queryKey: AgreementsDashboardQueryKeys.list,
    queryFn: async () =>
      (await ApiInstance.post(AgreementsDashboardQueryKeys.list.endpoint, { dealer_id: selectedDealer?.id || 0 }, AgreementsDashboardQueryKeys.list.baseUrl)).data
        .communication_agreements,
    enabled: !!selectedDealer?.id
  });
};
